import { useForm } from 'react-hook-form'
import { CiSearch } from 'react-icons/ci'

import { Input } from '@/components/input'
import { Form } from '@/components/ui/form'

interface BuscaPrêmiosProps {
  onSubmit: () => void
}

export const BuscaPrêmios = ({ onSubmit }: BuscaPrêmiosProps) => {
  const formContext = useForm<{
    busca: string
  }>()

  return (
    <Form {...formContext}>
      <form
        onSubmit={formContext.handleSubmit(onSubmit)}
        className='w-full space-y-4'
      >
        <div className='relative'>
          <Input
            control={formContext.control}
            registerName='busca'
            placeholder='Pesquisar por nome'
            type='text'
            className='rounded-xl border bg-transparent'
          />

          <div
            className='absolute right-5 top-3 cursor-pointer text-esforce-green-200'
            onClick={onSubmit}
          >
            <CiSearch size={24} />
          </div>
        </div>
      </form>
    </Form>
  )
}
